var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%" } },
    [
      _c(
        "div",
        {
          staticClass: "map",
          attrs: {
            id: "map",
            type: "light",
            streetview: "disabled",
            oncontextmenu: "return false"
          }
        },
        [
          _c("change-map-type-button", {
            attrs: { viewIsAerial: _vm.isAerial },
            on: { click: _vm.changeViewType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.drawPolygon
        ? [
            _c(
              "div",
              { staticClass: "map-buttons" },
              [
                _c(
                  "management-button",
                  {
                    staticClass: "map-button",
                    attrs: { type: "execute", label: _vm.$t("UploadFile") },
                    on: {
                      buttonClick: function($event) {
                        _vm.dialog = true
                      }
                    }
                  },
                  [_c("UploadIcon", { staticClass: "icon" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "management-button",
                  {
                    staticClass: "map-button",
                    attrs: {
                      type: "execute",
                      label: _vm.$t("StartOver"),
                      disabled: !_vm.drawing
                    },
                    on: { buttonClick: _vm.resetPolygon }
                  },
                  [
                    _c("StartOverSVG", {
                      staticClass: "icon",
                      class: { disabled: !_vm.drawing }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { "max-width": "790", width: "530", persistent: "" },
                model: {
                  value: _vm.dialog,
                  callback: function($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog"
                }
              },
              [
                _c(
                  "v-card",
                  { staticClass: "delete-modal" },
                  [
                    _c("v-card-title", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.$t("UploadFile")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-main",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "input-field-container",
                                staticStyle: { "margin-bottom": "10px" }
                              },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$tc("Type", 1)))
                                ]),
                                _vm._v(" "),
                                _c("treeselect", {
                                  attrs: {
                                    options: _vm.typeSelectOptions,
                                    placeholder: null,
                                    searchable: false
                                  },
                                  model: {
                                    value: _vm.typeSelect,
                                    callback: function($$v) {
                                      _vm.typeSelect = $$v
                                    },
                                    expression: "typeSelect"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-field-container" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$tc("Projection", 1)))
                                ]),
                                _vm._v(" "),
                                _c("treeselect", {
                                  attrs: {
                                    options: _vm.projectionOptions,
                                    "load-options": _vm.loadProjections,
                                    placeholder: null,
                                    disableFuzzyMatching: ""
                                  },
                                  model: {
                                    value: _vm.projection,
                                    callback: function($$v) {
                                      _vm.projection = $$v
                                    },
                                    expression: "projection"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("drop-file-area", {
                              ref: "dropFileArea",
                              staticStyle: { "padding-top": "20px" },
                              attrs: {
                                "file-types": _vm.acceptedFileTypes,
                                disabled: !_vm.fileSelectionEnabled
                              },
                              on: {
                                updateFile: function($event) {
                                  _vm.dropzoneFile = $event
                                },
                                trashFile: function($event) {
                                  _vm.dropzoneFile = null
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      { staticStyle: { padding: "8px 32px" } },
                      [
                        _c("div", { staticClass: "flex-grow-1" }),
                        _vm._v(" "),
                        _c("management-button", {
                          attrs: { type: "cancel", label: _vm.$t("Cancel") },
                          on: {
                            buttonClick: function($event) {
                              return _vm.cancelForm()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("management-button", {
                          attrs: {
                            type: "execute",
                            label: _vm.$t("Submit"),
                            disabled: !_vm.buttonActive
                          },
                          on: {
                            buttonClick: function($event) {
                              return _vm.submitForm()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-415117cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415117cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewMap.vue
// module id = null
// module chunks = 